var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.annonce !== '')?_c('div',{staticClass:"actu-mobi p-2"},[_c('p',{staticClass:"m-1"},[_vm._v(" "+_vm._s(_vm.annonce)+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }